import React, { Fragment, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Message, Button, Container } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { form_load } from "../../../features/patientelle/patientelleSlice";

import axios from "axios";
import { server } from "../../../App";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"

function DeletePatientelle() {
  const [isdeleted, setIisdeleted] = useState(false);
  const dispatch = useDispatch();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const { idpatient, nom, prenom, civilite, date_naissance } = PatientelleState;
  sessionStorage.setItem("ID_Session", PatientelleState.idpatient);

  const initialState = {
    idpatient: "",
    nom: "",
    prenom: "",
    civilite: "",
    nom_mutuelle: "",
    fk_id_liste_mutuelle: "",
    fk_id_civilite: "",
    cin: "",
    date_naissance: "",
    commentaire_sur_patient: "",
    tel: "",
    tel2: "",
    tel3: "",
  };
  const deletehandler = async (ID) => {
    await axios({
      method: "delete",
      responseType: "json",
      url: `${server}users/${ID}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch(form_load(initialState));
        toast.success("Success", {
          position: toast.POSITION.TOP_CENTER,
        });
        setIisdeleted(true);
      })
      .catch((err) =>
        toast.error("error", {
          position: toast.POSITION.TOP_CENTER,
        })
      );
  };

  return (
    <Fragment>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          {!isdeleted ? (
            <Message color="orange">
              <Message.Header>
                Voulez-vous supprimer {civilite} {nom} {prenom} {date_naissance}{" "}
                ?{" "}
              </Message.Header>
            </Message>
          ) : (
            <Message color="green">
              <Message.Header>
                le patient a été supprimé avec succès
              </Message.Header>
            </Message>
          )}

          <Button
            floated="right"
            negative
            onClick={() => {
              deletehandler(idpatient);
            }}
          >
            Supprimer
          </Button>
          <Link to="/">
            <Button floated="right" color="blue">
              retour
            </Button>
          </Link>
        </Container>
        <SpeedDialComponent />
      </div>
    </Fragment>
  );
}

export default DeletePatientelle;
